
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class TbnnTable extends Vue {
    //同比牛牛
    table = {
        data: [],
        column: [
            {
                key: 'black',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].RealAWard)
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = strzo[bulidUid(params.row.user_id, strzo)].PercentPoin ? (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].PercentPoin) : 0
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '玩家手牌',
                align: 'center',
                width: 250,
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = strzo[bulidUid(params.row.user_id, strzo)]
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: str.C.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '赢家手牌',
                align: 'center',
                width: 250,
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str: any
                    for (let key in strzo) {
                        if (strzo[key].RealAWard > 0) {
                            str = strzo[String(key)]
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: str.C.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            }
        ]
    }

    @Prop()
    listdata
}
